/** Animation duration for appearing queries in Query Management Panel */
export const animationDuration = 2000;
